import React, { CSSProperties } from "react";
import { AderantTheme } from "@aderant/aderant-react-components";
import { getSourceTypeDisplayValue } from "Functions/strings";
import { HitResult } from "pages/ResultsPage/HitResult";
import { conflictsPalette } from "styles/conflictsPalette";
import { aderantColors } from "@aderant/aderant-react-components";

interface FlyoutHeaderProps {
    hitResultName: string;
    data?: HitResult;
    commentCount: number;
    showComments: boolean;
}

const headingContainer: CSSProperties = {
    padding: "15px",
    borderBottom: `1px solid ${conflictsPalette.border}`,
    backgroundColor: conflictsPalette.background.white
};

const flyoutHeading: CSSProperties = {
    fontWeight: 400,
    textAlign: "center",
    fontSize: AderantTheme.typography.pxToRem(20),
    margin: 0,
    color: aderantColors.DarthVader
};

const flyoutSubheading: CSSProperties = {
    textAlign: "center",
    fontSize: AderantTheme.typography.pxToRem(14),
    margin: 0,
    color: aderantColors.DarthVaderAlt
};

// formatting helpers extracted for testability and reuse
const formatCommentSubtitle = (count: number): string => `${count} Comment${count === 1 ? '' : 's'}`;
const formatHitTypeSubtitle = (sourceType?: string): string => {
    if (!sourceType) return '';
    return `Hit Type: ${getSourceTypeDisplayValue(sourceType)}`;
};

export const FlyoutHeader = ({ hitResultName, data, commentCount, showComments }: FlyoutHeaderProps): JSX.Element => {
    const subtitle: string = showComments
        ? formatCommentSubtitle(commentCount)
        : formatHitTypeSubtitle(data?.hit?.sourceType);

    return (
        <div style={headingContainer}>
            <h2 data-testid={"flyout-title"} style={flyoutHeading}>
                {hitResultName}
            </h2>
            {subtitle && (
                <p style={flyoutSubheading} data-testid="flyout-subtitle">
                    {subtitle}
                </p>
            )}
        </div>
    );
};
